<template>
  <footer class="footer-container">
    <div class="footer-content">
      <div class="footer-section">
        <h3>关于天门衣尚</h3>
        <p>天门衣尚致力于为服装产业提供全方位的信息服务平台，连接优质服装供应商与采购商，促进产业链协同发展。</p>
      </div>
      <div class="footer-section">
        <h3>联系方式</h3>
        <p>电话：15346660983</p>
        <p>邮箱：tmys@tianmenyishang.cn</p>
        <p>地址：湖北省天门市天仙大道特一号</p>
      </div>
      <div class="footer-section">
        <h3>快速链接</h3>
        <router-link to="/about">关于我们</router-link>
        <router-link to="/news">新闻资讯</router-link>
        <router-link to="/shop">在线商城</router-link>
        <router-link to="/supply-demand">供需对接</router-link>
      </div>
      <div class="footer-section">
        <h3>关注我们</h3>
        <div class="social-links">
          <a href="#" target="_blank" class="social-link" style="text-align: center;" @mouseenter="showQRCode" @mouseleave="hideQRCode">
            企业微信
            <img src="@/assets/qr-codes/wechat.png" alt="企业微信二维码" class="qr-code" />
          </a>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <p>&copy; 2024- 天门衣尚. All rights reserved.</p>
      <p>
        <span>
          <a href="javascript:void(0);" @click="() => openLicenseModal('business')" class="beian-link">公司营业执照</a>
        </span>
        <span style="margin-left: 10px;">
          <a href="javascript:void(0);" @click="() => openLicenseModal('hr')" class="beian-link">人力资源服务许可证</a>
        </span>
        <span style="margin-left: 10px;">
          <a href="https://beian.miit.gov.cn" target="_blank" class="beian-link">鄂ICP备2024083368号-1</a>
        </span>
        <span style="margin-left: 10px;">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=42900602000350" target="_blank" class="beian-link" style="display: inline-flex; align-items: center;">
            <img src="https://www.beian.gov.cn/img/ghs.png" style="height: 18px; margin-right: 4px;" alt="公安备案图标"/>
            鄂公网安备42900602000350号
          </a>
        </span>
      </p>
      <!-- 执照弹窗 -->
      <div v-if="showLicenseModal" class="license-modal-overlay" @click.self="closeLicenseModal">
        <div class="license-modal-content">
          <img v-if="licenseModalType === 'business'" src="@/assets/licenses/1d6e4f4c140c0ad154022fd5d0eb39e.jpg" alt="公司营业执照" style="max-width: 90vw; max-height: 70vh; border-radius: 8px; background: #fff; border: 1px solid #eee;" />
          <img v-else-if="licenseModalType === 'hr'" src="@/assets/licenses/074f43f8c9f1cde5d2d14b80d682139.jpg" alt="人力资源服务许可证" style="max-width: 90vw; max-height: 70vh; border-radius: 8px; background: #fff; border: 1px solid #eee;" />
          <button class="license-modal-close" @click="closeLicenseModal">关闭</button>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { defineOptions } from 'vue';
import { ref } from 'vue';

defineOptions({
  name: 'MainFooter'
});

const showQRCode = (event) => {
  const qrCode = event.target.querySelector('.qr-code');
  if (qrCode) {
    qrCode.style.display = 'block';
    qrCode.style.opacity = 1;
    qrCode.style.transform = 'translate(-50%, -50%) scale(1)';
  }
};

const hideQRCode = (event) => {
  const qrCode = event.target.querySelector('.qr-code');
  if (qrCode) {
    qrCode.style.display = 'none';
    qrCode.style.opacity = 0;
    qrCode.style.transform = 'translate(-50%, -50%) scale(0)';
  }
};

// 新增：执照弹窗逻辑
const showLicenseModal = ref(false);
const licenseModalType = ref('business'); // 'business' or 'hr'
const openLicenseModal = (type) => {
  licenseModalType.value = type;
  showLicenseModal.value = true;
};
const closeLicenseModal = () => {
  showLicenseModal.value = false;
};
</script>

<style scoped>
.footer-container {
  background: linear-gradient(135deg, rgba(45, 35, 75, 0.97), rgba(65, 55, 95, 0.97));
  padding: 50px 0 30px;
  color: #E6E6FA;
  margin-top: auto;
  position: relative;
  overflow: hidden;
  box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.1);
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 20px;
  gap: 30px;
}

.footer-section {
  flex: 1;
  min-width: 250px;
}

.footer-section h3 {
  color: #D4AF37;
  font-size: 20px;
  margin-bottom: 20px;
  text-align: left;
  font-weight: 500;
  letter-spacing: 1px;
  font-family: "Helvetica Neue", Arial, sans-serif;
  position: relative;
  padding-bottom: 10px;
}

.footer-section h3::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: left;
  width: 40px;
  height: 2px;
  background: #D4AF37;
  transition: width 0.3s ease;
}

.footer-section:hover h3::after {
  width: 60px;
}

.footer-section p {
  margin: 12px 0;
  font-size: 15px;
  line-height: 1.8;
  text-align: left;
  color: rgba(230, 230, 250, 0.9);
  transition: color 0.3s ease;
}

.footer-section a {
  display: block;
  color: rgba(230, 230, 250, 0.9);
  text-align: left;
  text-decoration: none;
  margin: 12px 0;
  font-size: 15px;
  transition: all 0.3s ease;
  position: relative;
  padding-left: 0;
}

.footer-section a:hover {
  color: #D4AF37;
  transform: translateX(10px);
  padding-left: 5px;
}

.social-links {
  display: flex;
  gap: 15px;
  text-align: center;
  margin-top: 10px;
  justify-content: center;
  flex-wrap: wrap;
}

.social-link {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 12px 20px;
  border-radius: 6px;
  background: rgba(212, 175, 55, 0.1);
  backdrop-filter: blur(5px);
  transition: all 0.3s ease;
  border: 1px solid rgba(212, 175, 55, 0.2);
  position: relative;
  margin: 5px;
  min-width: 100px;
  cursor: pointer;
}

.social-link:hover {
  background: rgba(212, 175, 55, 0.2);
  transform: translateY(-2px);
  border-color: rgba(212, 175, 55, 0.4);
  box-shadow: 0 5px 15px rgba(212, 175, 55, 0.1);
}

.qr-code {
  position: absolute;
  top: 100%; /* 修改为相对于父元素底部 */
  left: 50%;
  transform: translate(-50%, 20px) scale(0); /* 修改Y轴偏移为正值 */
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.98);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;
  padding: 20px;
  border: 1px solid rgba(212, 175, 55, 0.3);
  backdrop-filter: blur(12px);
  z-index: 9999;
  display: none;
}

.social-link:hover .qr-code {
  transform: translate(-50%, 20px) scale(1); /* 保持Y轴偏移为正值 */
  opacity: 1;
  display: block;
}

.qr-code::before {
  content: '';
  position: absolute;
  top: -8px; /* 修改箭头位置到顶部 */
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 16px;
  height: 16px;
  background: rgba(255, 255, 255, 0.95);
  border-left: 1px solid rgba(212, 175, 55, 0.2); /* 修改边框方向 */
  border-top: 1px solid rgba(212, 175, 55, 0.2); /* 修改边框方向 */
  backdrop-filter: blur(8px);
}

.license-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}
.license-modal-content {
  background: #222;
  padding: 24px 24px 16px 24px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.license-modal-close {
  margin-top: 16px;
  padding: 6px 18px;
  background: #D4AF37;
  color: #222;
  border: none;
  border-radius: 4px;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s;
}
.license-modal-close:hover {
  background: #bfa13a;
}

@media screen and (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 20px;
  }

  .footer-section {
    min-width: 100%;
    text-align: center;
  }

  .footer-section p,
  .footer-section a {
    text-align: center;
  }

  .social-links {
    justify-content: center;
  }

  .qr-code {
    width: 100px;
    height: 100px;
  }

  .footer-bottom {
    text-align: center;
    padding: 20px;
    margin-top: 30px;
    border-top: 1px solid rgba(230, 230, 250, 0.1);
  }

  .footer-bottom p {
    margin: 5px 0;
    font-size: 14px;
    color: rgba(230, 230, 250, 0.7);
  }

  .beian-link {
    color: rgba(230, 230, 250, 0.7);
    text-decoration: none;
    transition: color 0.3s ease;
  }

  .beian-link:hover {
    color: #D4AF37;
    text-align: left;
  }
}
</style>